import React from 'react';
import './Footer.css';
import logo from '../logo.jpg';          // Replace with your actual logo
import mapIcon from '../map-icon.jpg';   // Replace with your actual map icon

const Footer = () => {
  return (
    <footer className="custom-footer"
    style={{
                position: 'relative',
                minHeight: '100%',
                width: '100%',
                backgroundImage: 'url(/assets/footer.png)',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                zIndex: 0,
                marginBottom: 0,
                paddingBottom: 0
            }}>
      <div className="footer-content" >
        <div className="footer-right" >
          {/** <img src={logo} alt="Auto Bauer Logo" className="footer-logo" />*/}
          <p>
            LAM Autoservice<br />
            Schwarzbach 152<br />
            42277 Wuppertal<br />
            Tel: +49 176 72987527<br />
            <a
                href="https://maps.app.goo.gl/4eDnBybKuX6SYjxV9"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-left"
                >
                <p className="footer-label">
                    <strong>DER WEG<br />ZU UNS:</strong>
                </p>
                <img src={mapIcon} alt="Map Icon" className="map-icon" />
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
